module.exports = __webpack_public_path__ + "img/11.ad17ab85.jpg";